import React, {useEffect, useRef, useState} from "react";

type Props = {
    className: string,
    buttonText: string | any,
    children: any
}

const Dropdown = (props: Props) => {
    const dropdown: any = useRef<HTMLInputElement>(null);
    const [isOpen, toggle] = useState(false);
    
    // Handle click outstied dropdown
    useEffect(() => {
        document.addEventListener("click", handleClick);
        return () => {
            document.removeEventListener("click", handleClick);
        };
    }, []);
    
    const handleClick = (e: any) => {
        if (dropdown.current && dropdown.current.contains(e.target)) {
            if (e.target.classList.contains("dropdown-item")) {
                setTimeout(() => toggle(false), 100);
            }
        } else {
            toggle(false);
        }
    }

    return (
        <div className={`dropdown ${isOpen ? "show" : ""} ${props.className ? props.className : ""}`} ref={dropdown}>
            <button className="btn btn-link dropdown-toggle" type="button" onClick={() => toggle(!isOpen)}>
                {props.buttonText}
            </button>
            <div className={`dropdown-menu ${isOpen ? "show" : ""}`}>
                <div className="dropdown-caret top"></div>
                {props.children}
            </div>
        </div>
    );
};

export default Dropdown;
